import { useState, useEffect, useCallback, useRef } from "react";
import { useHistory } from "react-router";
import axios from "axios";
import dayjs from "dayjs";
import { traerTurnosPaciente } from "../../apiClient/rutes/turnos";
import {
  obtenerHorariosYTurnosImagenes,
  manejarReservaTurnoImagenes,
} from "./turnosServiceImagenes";
import {
  verificarInasistenciasPorEstudio,
  verificarTurnoConPrestadorPendiente,
} from "./nuevoTurnoImagenesUtils";

export const useNuevoTurnoImagenes = (mostrarNotificacion) => {
  const [cargando, setCargando] = useState(false);
  const [cargandoTurnos, setCargandoTurnos] = useState(false);
  const [usuario, setUsuario] = useState({});
  const [urlAxioPP, setUrlAxio] = useState("");
  const [estudios, setEstudios] = useState([]);
  const [prestadores, setPrestadores] = useState([]);
  const [listadoPrestadores, setListadoPrestadores] = useState([]);
  const [estudioSeleccionado, setEstudioSeleccionado] = useState(-1);
  const [prestadorSeleccionado, setPrestadorSeleccionado] = useState(-1);
  const [fechasFuturas, setFechasFuturas] = useState([]);
  const [fechaSeleccionada, setFechaSeleccionada] = useState("");
  const [turnosPaciente, setTurnosPaciente] = useState([]);
  const [turnosDisponibles, setTurnosDisponibles] = useState([]);
  const [turnosPublicados, setTurnosPublicados] = useState([]);
  const [turnoSeleccionado, setTurnoSeleccionado] = useState({});
  const [mostrarInasisEstudio, setMostrarInasisEstudio] = useState(false);
  const [mostrarTurnoPrestadorReservado, setMostrarTurnoPrestadorReservado] =
    useState(false);
  const [abrirDesplegableEstudios, setAbrirDesplegableEstudios] =
    useState(false);
  const [abrirDesplegablePrestadores, setAbrirDesplegablePrestadores] =
    useState(false);
  const [abrirModalConfirmarReserva, setAbrirModalConfirmarReserva] =
    useState(false);
  const [abrirModalPostReserva, setAbrirModalPostReserva] = useState(false);

  const history = useHistory();

  // Función para traer estudios/equipos
  const traerEstudios = async (paciente) => {
    let estudios = [];
    const url = localStorage.getItem("urlAxioPP");
    const config = {
      headers: { Authorization: `Bearer ${paciente.token}` },
    };

    try {
      // Intentar primero con el endpoint Estudios
      let response = await axios.get(`${url}Estudios`, config);

      // Si viene vacío, usar el endpoint de Equipos
      if (!response.data || response.data.length === 0) {
        response = await axios.get(`${url}Equipos`, config);
      }

      if (response.data && response.data.length !== 0) {
        estudios = response.data;
      }

      estudios = estudios.map((estudio) => {
        return {
          ...estudio,
          text: estudio.nombre,
        };
      });

      setEstudios(estudios);
    } catch (e) {
      console.error("[traerEstudios] Error:", e);
      mostrarNotificacion(
        true,
        "Se produjo un error al consultar los estudios registrados en el sistema",
        "rojo",
      );
    }
  };

  // Función para cargar desplegables
  const CargarDesplegables = async (sesion) => {
    await traerEstudios(sesion);
  };

  const obtenerTurnosPrestador = useCallback(
    async (prestador) => {
      setCargandoTurnos(true);
      try {
        const resultado = await obtenerHorariosYTurnosImagenes(
          prestador,
          usuario,
          urlAxioPP,
        );

        if (resultado.success) {
          setFechasFuturas(resultado.turnosProximos);
          setTurnosDisponibles(resultado.turnosDisponibles);
          setTurnosPublicados(resultado.turnosPublicados || []);
          setFechaSeleccionada(resultado.fechaSeleccionada);

          if (
            !resultado.turnosDisponibles ||
            resultado.turnosDisponibles.length === 0
          ) {
            mostrarNotificacion(
              true,
              "No hay turnos disponibles para este equipo.",
              "amarillo",
            );
          }
        } else {
          mostrarNotificacion(true, resultado.error, "rojo");
          setFechasFuturas([]);
          setTurnosDisponibles([]);
          setTurnosPublicados([]);
          setFechaSeleccionada("");
        }
      } catch (error) {
        console.error("[ERROR] obtenerTurnosPrestador:", error);
        mostrarNotificacion(true, "Error inesperado: " + error.message, "rojo");
        setTurnosPublicados([]);
      }
      setCargandoTurnos(false);
    },
    [usuario, urlAxioPP, mostrarNotificacion],
  );

  const estudioModalAbierto = useRef(false);

  const handleChangeSelect = (value, select) => {
    if (select === "Estudio") {
      setEstudioSeleccionado(value);
      setFechasFuturas([]);
      setTurnosPublicados([]);
      if (value !== -1) {
        if (verificarInasistenciasPorEstudio(value, turnosPaciente)) {
          setMostrarInasisEstudio(true);
          setMostrarTurnoPrestadorReservado(false);
        } else {
          setMostrarInasisEstudio(false);
          if (verificarTurnoConPrestadorPendiente(value, turnosPaciente)) {
            setMostrarTurnoPrestadorReservado(true);
            setMostrarInasisEstudio(false);
          } else {
            setMostrarTurnoPrestadorReservado(false);
            // Cargar turnos directamente para el estudio seleccionado
            obtenerTurnosPrestador(value);
          }
        }
      }
      return;
    }
    mostrarNotificacion(true, "Selección inválida", "rojo");
    return;
  };

  // useEffect inicial - Carga de datos al montar el componente
  useEffect(() => {
    setCargando(true);
    try {
      const sesion = JSON.parse(sessionStorage.getItem("ppUL"));
      if (sesion) {
        traerTurnosPaciente(sesion).then((turnos) => {
          setTurnosPaciente(turnos);
        });
        CargarDesplegables(sesion);
        setUsuario(sesion);
        setUrlAxio(localStorage.getItem("urlAxioPP"));
        document.title = localStorage.getItem("tituloWeb");
      }
    } catch (e) {
      console.error("[useEffect] Error:", e);
      history.push({ pathname: "/ErrorPage" });
    }
    setCargando(false);
  }, []);

  const seleccionInicial = useRef(false);
  const prestadorSeleccionadoExternamente = useRef(false);
  useEffect(() => {
    if (
      !seleccionInicial.current &&
      estudios.length > 0 &&
      prestadores.length > 0 &&
      prestadorSeleccionado === -1
    ) {
      const prestadorExterno = history.location.state?.prestador;
      if (prestadorExterno !== undefined && prestadorExterno !== null) {
        const prestadorEncontrado = prestadores.find(
          (prestador) =>
            prestador.codigo.split("-")[0] === prestadorExterno.toString(),
        );
        if (prestadorEncontrado) {
          seleccionInicial.current = true;
          prestadorSeleccionadoExternamente.current = true;
          setEstudioSeleccionado(prestadorEncontrado.estudio);
          const prestadoresFiltrados = prestadores.filter(
            (prestador) =>
              prestador.estudio === prestadorEncontrado.estudio ||
              prestador.estudio2 === prestadorEncontrado.estudio,
          );
          setListadoPrestadores(prestadoresFiltrados);
          setPrestadorSeleccionado(prestadorEncontrado.codigo);
          if (verificarInasistenciasPorEstudio) {
            const turnosSafe = Array.isArray(turnosPaciente)
              ? turnosPaciente
              : [];
            if (
              verificarInasistenciasPorEstudio(
                prestadorEncontrado.estudio,
                turnosSafe,
              )
            ) {
              setFechasFuturas([]);
              setMostrarInasisEstudio(true);
              setMostrarTurnoPrestadorReservado(false);
            } else {
              setMostrarInasisEstudio(false);
              if (verificarTurnoConPrestadorPendiente) {
                if (
                  verificarTurnoConPrestadorPendiente(
                    prestadorEncontrado.codigo,
                    turnosSafe,
                  )
                ) {
                  setFechasFuturas([]);
                  setMostrarTurnoPrestadorReservado(true);
                  setMostrarInasisEstudio(false);
                } else {
                  setMostrarTurnoPrestadorReservado(false);
                  obtenerTurnosPrestador(prestadorEncontrado.codigo);
                }
              }
            }
          }
          mostrarNotificacion(
            true,
            `Cargando horarios para ${prestadorEncontrado.nombre || prestadorEncontrado.text || prestadorEncontrado.label}...`,
            "verde",
          );
        } else {
          mostrarNotificacion(
            true,
            "El prestador seleccionado no está disponible, seleccione un estudio",
            "amarillo",
          );
          setAbrirDesplegableEstudios(true);
        }
        history.location.state = {};
      } else {
        if (estudioSeleccionado === -1 && !estudioModalAbierto.current) {
          estudioModalAbierto.current = true;
          setAbrirDesplegableEstudios(true);
        }
        prestadorSeleccionadoExternamente.current = false;
      }
    }
  }, [
    prestadores,
    estudios,
    history,
    prestadorSeleccionado,
    estudioSeleccionado,
    mostrarNotificacion,
    setEstudioSeleccionado,
    setListadoPrestadores,
    setPrestadorSeleccionado,
    setFechasFuturas,
    obtenerTurnosPrestador,
    turnosPaciente,
  ]);

  const handleClickConfirmarHacerReserva = useCallback(async () => {
    setCargando(true);
    try {
      const resultado = await manejarReservaTurnoImagenes(
        turnoSeleccionado,
        usuario,
        estudioSeleccionado,
        urlAxioPP,
      );
      if (resultado.success) {
        mostrarNotificacion(true, resultado.mensaje, "verde");
        setAbrirModalConfirmarReserva(false);
        setFechaSeleccionada("");
        setTurnosDisponibles([]);
        setAbrirModalPostReserva(true);
      } else {
        mostrarNotificacion(true, resultado.error, "rojo");
      }
    } catch (error) {
      mostrarNotificacion(true, "Error inesperado: " + error.message, "rojo");
    }
    setCargando(false);
  }, [
    turnoSeleccionado,
    usuario,
    estudioSeleccionado,
    urlAxioPP,
    mostrarNotificacion,
  ]);

  const handleClickSeleccionarTurno = useCallback((turno) => {
    setTurnoSeleccionado(turno);
    setAbrirModalConfirmarReserva(true);
  }, []);

  const handleChangeFecha = useCallback((value) => {
    setFechaSeleccionada(value);
  }, []);

  const handleClickCopiarTelefono = useCallback(() => {
    const phoneNumber = "08105552765";
    navigator.clipboard.writeText(phoneNumber);
    mostrarNotificacion(
      true,
      "Se ha copiado el número de teléfono a su portapapeles",
      "",
    );
  }, [mostrarNotificacion]);

  const handlePostTurnoReservado = useCallback(
    (accion) => {
      setTurnoSeleccionado({});
      setAbrirModalPostReserva(false);
      switch (accion) {
        case "nuevoTurno":
          window.location.reload();
          break;
        case "turnosPaciente":
          history.push({ pathname: "/portal/Turnos" });
          break;
        default:
          history.push({ pathname: "/portal/Turnos" });
          break;
      }
    },
    [history],
  );

  const renderTurnos = useCallback(() => {
    const turnos = turnosDisponibles.filter(
      (turno) =>
        dayjs(turno.fecha).format("YYYY-MM-DD") ===
        dayjs(fechaSeleccionada).format("YYYY-MM-DD"),
    );
    return turnos.map((turno) => (
      <button
        key={turno.codigo}
        onClick={() => handleClickSeleccionarTurno(turno)}
        className="turno-button"
      >
        {dayjs(turno.hora).format("HH:mm")}
      </button>
    ));
  }, [turnosDisponibles, fechaSeleccionada, handleClickSeleccionarTurno]);

  const getPrestadorSeleccionadoData = useCallback(() => {
    return (
      prestadores.find(
        (prestador) => prestador.codigo === prestadorSeleccionado,
      ) || {}
    );
  }, [prestadores, prestadorSeleccionado]);

  const getEstudioSeleccionadoData = useCallback(() => {
    return (
      estudios.find((estudio) => estudio.codigo === estudioSeleccionado) || {}
    );
  }, [estudios, estudioSeleccionado]);

  const estudiosDesplegable = estudios.map((e) => ({
    codigo: e.codigo ?? e.id ?? "",
    text: e.text ?? e.nombre ?? e.label ?? "",
    ...e,
  }));
  const prestadoresDesplegable = listadoPrestadores.map((p) => ({
    codigo: p.codigo ?? p.id ?? "",
    text: p.text ?? p.nombre ?? p.label ?? "",
    ...p,
  }));

  return {
    usuario,
    urlAxioPP,
    cargando,
    cargandoTurnos,
    estudios,
    prestadores,
    estudios,
    listadoPrestadores,
    estudiosDesplegable,
    prestadoresDesplegable,
    estudioSeleccionado,
    prestadorSeleccionado,
    fechasFuturas,
    fechaSeleccionada,
    turnosDisponibles,
    turnosPublicados,
    turnoSeleccionado,
    mostrarInasisEstudio,
    mostrarTurnoPrestadorReservado,
    abrirDesplegableEstudios,
    abrirDesplegablePrestadores,
    abrirModalConfirmarReserva,
    abrirModalPostReserva,
    setEstudioSeleccionado,
    setPrestadorSeleccionado,
    setFechaSeleccionada,
    setTurnoSeleccionado,
    setAbrirDesplegableEstudios,
    setAbrirDesplegablePrestadores,
    setAbrirModalConfirmarReserva,
    setAbrirModalPostReserva,
    handleChangeSelect,
    handleChangeFecha,
    handleClickSeleccionarTurno,
    handleClickConfirmarHacerReserva,
    handleClickCopiarTelefono,
    handlePostTurnoReservado,
    renderTurnos,
    getPrestadorSeleccionadoData,
    getEstudioSeleccionadoData,
  };
};
